export class CadCooperativesFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getCooperatives(filter) {
    return this.instance.get('/v1/cad-cooperativas/', {
      params: filter || null,
    });
  }

  getCooperative(filter, id) {
    return this.instance.get(`/v1/cad-cooperativas/${id}`, {
      params: filter || null,
    });
  }

  addCooperative(data) {
    return this.instance.post(`/v1/cad-cooperativas/`, data);
  }

  editCooperative(id, data) {
    return this.instance.put(`/v1/cad-cooperativas/${id}`, data);
  }

  deleteCooperative(id) {
    return this.instance.delete(`/v1/cad-cooperativas/${id}`);
  }
}

export default (...params) => new CadCooperativesFactory(...params);
